// Copyright (c) StrangeBee 2024

import { Space } from 'antd';
import React, { ReactElement, ReactNode } from 'react';
import { UserOutput } from 'thehive-sdk';
import { ICONS } from '@Constants/iconsApp';

import './UserListCheckboxCell.scss';

interface UserListCheckboxCellProps {
    locked: UserOutput['locked'];
    hasMFA: UserOutput['hasMFA'];
    checkbox: ReactNode;
}

const UserListCheckboxCell = ({ locked, checkbox }: UserListCheckboxCellProps): ReactElement => (
    <Space direction="vertical" size={1}>
        {checkbox}

        {locked && <ICONS.LockFilled className="user-list-checkbox-cell__lock" />}
    </Space>
);

export default UserListCheckboxCell;
